import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Button from 'components/Button';
import { useHistory } from 'react-router-dom';
import Color from 'components/Color';
import ProductTags from 'pages/browse-catalog/ProductTags';
import { ROUTES } from 'shared/constants/routes';
import WarningIcon from '@material-ui/icons/Warning';
import Image from 'components/Image';
import Tooltip from '@material-ui/core/Tooltip';
import USAFlag from 'assets/images/usa-flag.png';
import CADFlag from 'assets/images/canada-flag.png';
import EUFlag from 'assets/images/eu-flag.png';
import AUFlag from 'assets/images/aus-flag.jpeg';
import { USD_TO_CAD_CONVERSION_RATE } from 'constants/currency';
import {
  Container,
  ItemGroup,
  Item,
  ProductLink,
  ProductImage,
  Description,
  Text,
  Amount,
  Colors,
  NoProdcuts,
} from 'styles/pages/browse-catalog/details.js';

const Details = ({ resetFilters, products }) => {
  const history = useHistory();
  const currency = useSelector((state) => state?.currency?.value);

  return (
    <Container>
      {!!products?.length ? (
        <ItemGroup>
          {products.map((item, index) => {
            const product = item.Product;
            const colors = item.Colors;
            const price =
              item?.Sizes[0]?.ColoredPrice +
              (item?.Sizes[0][`${item?.Product?.PrintType}Price`] || 0);
            const discount = item?.discount || 0;
            const discountValue = (price * discount) / 100;
            const actualValue = (price - discountValue).toFixed(2);

            return (
              <Item
                key={`productsCatalog${index}`}
                onClick={() =>
                  history.push(`${ROUTES.PRODUCT_DETAIL.LINK}/${product.ID}`)
                }
              >
                {item?.PrintProviders?.map((printProvider, index) => (
                  <Tooltip
                    arrow={true}
                    key={`printProvider${index}`}
                    title={`${printProvider.ProviderName} Fulfillment Plant`}
                    placement="top"
                  >
                    <img
                      alt="products"
                      style={{
                        position: 'absolute',
                        top: 3,
                        left: index === 0 ? 4 : index * 35,
                      }}
                      src={
                        printProvider.ProviderName === 'CA'
                          ? CADFlag
                          : printProvider.ProviderName === 'US' ||
                            printProvider.ProviderName === 'NY'
                          ? USAFlag
                          : printProvider.ProviderName === 'EU'
                          ? EUFlag
                          : AUFlag
                      }
                      width="30"
                    />
                  </Tooltip>
                ))}
                <ProductTags tags={product.ProductTags} />

                <ProductLink>
                  <ProductImage>
                    <Image
                      src={product.MarketingImagePath}
                      alt={product.DisplayName}
                    />
                  </ProductImage>
                  <Description>
                    <Text>{product.DisplayName}</Text>
                    <Amount>
                      from&nbsp;$
                      {currency === 'USD'
                        ? actualValue
                        : (
                            Number(actualValue) * USD_TO_CAD_CONVERSION_RATE
                          ).toFixed(2)}
                      &nbsp;
                      {currency === 'USD' ? 'USD' : 'CAD'}
                    </Amount>
                  </Description>
                  <Colors>
                    {colors.map((color, i) =>
                      color?.visible === false ? null : (
                        <Color
                          key={`productColor${i}`}
                          title={color.Name}
                          code={color.HexCode}
                        />
                      )
                    )}
                  </Colors>
                </ProductLink>
              </Item>
            );
          })}
        </ItemGroup>
      ) : (
        <NoProdcuts>
          <WarningIcon color="error" />
          <h1>No results matched your browsing filters</h1>
          <Button
            onClick={() => _.isFunction(resetFilters) && resetFilters()}
            containerStyle={{
              fontSize: '12px',
              borderRadius: '50px',
              padding: '5px 10px',
              color: '#fff',
              backgroundColor: '#000',
            }}
            title="Reset all filters"
          />
        </NoProdcuts>
      )}
    </Container>
  );
};

export default Details;
